import React from "react";
import "./Map.css";

export default function BengaluruMap() {
  return (
    <section className="bloremap-wrapper">
      <div className="bloremap-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3920.0937859457767!2d77.20249007504118!3d10.72724948941854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9b3543d7f390b%3A0x2da1e9aece44f0c5!2sUdumalpet%20-%20Senjeri%20Hills%20Rd%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1764161393276!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}
